import { useIntl } from 'react-intl';
import { formatSpokenLanguage } from '@_/utils';

export function FormattedSpokenLanguage({ value }: { value: string }) {
  const { locale } = useIntl();
  return formatSpokenLanguage(locale, value);
}
